export default __webpack_public_path__ + "static/media/Front End Development Libraries - Freecodecamp.3bf633ab.png";